import apiClient from '../utils/apiClient';

export async function getScheduleEmployees(params = {}) {
  const response = await apiClient.get('/api/schedule/employees', { params });
  return response.data;
}

export async function updateScheduleEmployeeVisibility(employeeId, hidden) {
  const response = await apiClient.put(`/api/schedule/employees/${employeeId}/visibility`, { hidden });
  return response.data;
}

export async function getActivityTypes() {
  const response = await apiClient.get('/api/schedule/activity-types');
  return response.data.activityTypes;
}

export async function createBooking(bookingData) {
  const response = await apiClient.post('/api/schedule/bookings', bookingData);
  return response.data;
}

export async function getBookings(startDate, endDate) {
  const response = await apiClient.get('/api/schedule/bookings', {
    params: {
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response.data;
}

export async function deleteBooking(bookingId) {
  const response = await apiClient.delete(`/api/schedule/bookings/${bookingId}`);
  return response.data;
}

export const updateBooking = async (bookingId, data) => {
  const response = await apiClient.put(`/api/schedule/bookings/${bookingId}`, data);
  return response.data;
};

// Export schedule to CSV
export async function exportSchedule(params = {}) {
  const response = await apiClient.get('/api/schedule/export', {
    params,
    responseType: 'blob' // Important for file downloads
  });

  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `schedule_export_${new Date().toISOString().split('T')[0]}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return response.data;
};
